<template>
  <div class="w-full h-[720px] rounded-[12px] relative">
    <canvas
      ref="container"
      class="absolute top-0 left-0 w-full h-full rounded-[12px] object-contain"
    ></canvas>
    <div
      v-if="loading"
      class="absolute top-0 left-0 w-full h-full flex-center bg-back-1 bg-opacity-50 z-10"
    >
      <a-spin />
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  url: string
  audioUrl?: string
  autoplay?: boolean
}>()

const loading = ref(false)
const playing = ref(false)
const container = ref<HTMLCanvasElement>()

const pagManage: any = {
  PAG: null,
  pagView: null,
  pagFile: null,
  audioPlayer: null,
}

const initPagPlayer = async () => {
  if (!props.url || !container.value) {
    return
  }

  loading.value = true
  const { PAGFile, PAGView } = await window.libpag.PAGInit()
  const buffer = await fetch(props.url).then((res) => res.arrayBuffer())
  const pagFile = await PAGFile.load(buffer)
  const pag_w = pagFile.width()
  const pag_h = pagFile.height()
  const target = 1280
  pagManage.pagFile = pagFile
  if (pag_w >= pag_h) {
    const ratio = target / pag_w
    container.value.width = target
    container.value.height = Math.round(pag_h * ratio)
  } else {
    const ratio = target / pag_h
    container.value.width = Math.round(pag_w * ratio)
    container.value.height = target
  }
  const pagView = await PAGView.init(pagFile, container.value, {
    useCanvas2D: true,
  })
  pagManage.pagView = pagView
  if (props.audioUrl) {
    pagManage.audioPlayer = new window.Audio(props?.audioUrl)
  }

  loading.value = false
  if (!pagView) {
    return
  }

  pagView.setRepeatCount(0)
  pagView.addListener('onAnimationStart', () => {
    playing.value = true
    pagManage.audioPlayer?.play()
  })
  pagView.addListener('onAnimationEnd', () => {
    playing.value = false
    pagManage.audioPlayer?.pause()
  })
  pagView.addListener('onAnimationPause', () => {
    playing.value = false
    pagManage.audioPlayer?.pause()
  })
  pagView.addListener('onAnimationCancel', () => {
    playing.value = false
    pagManage.audioPlayer?.pause()
  })
  pagView.addListener('onAnimationRepeat', () => {
    if (pagManage.audioPlayer) {
      pagManage.audioPlayer.currentTime = 0
    }
  })
  await pagView.play()
}

onMounted(() => {
  if (props.autoplay) {
    initPagPlayer()
  }
})

onUnmounted(() => {
  if (pagManage.audioPlayer) {
    pagManage.audioPlayer.pause()
    pagManage.audioPlayer = null
  }
  pagManage.pagFile?.destroy()
  pagManage.pagFile = null
  pagManage.pagView?.destroy()
  pagManage.pagView = null
})

defineExpose({
  play: () => initPagPlayer(),
  pause: () => pagManage.pagView?.pause(),
})
</script>
<style lang="scss"></style>
